import { formatCompanyId } from '@/utils/general';
import { TextField } from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';

type CompanyIDInputProps = {
  error?: boolean;
  name?: string;
  value?: string;
  onChange?: (name: string, value: string) => void;
};

export default function CompanyIDInput({
  error,
  name = 'companyId',
  value,
  onChange,
  ...props
}: CompanyIDInputProps) {
  const [formattedValue, setFormattedValue] = useState<string>('CHE-');

  useEffect(() => {
    if (value) {
      setFormattedValue(formatCompanyId(value));
    }
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatCompanyId(e.target.value);
    setFormattedValue(formattedValue);
    onChange?.(name, formattedValue);
  };

  return (
    <TextField
      {...props}
      fullWidth
      name={name}
      error={error}
      value={formattedValue}
      onChange={handleChange}
      placeholder='e.g. CHE-123.456.789'
      slotProps={{
        htmlInput: {
          'data-testid': 'company-id-input',
        },
      }}
    />
  );
}
